const initialState = {
  loading: false,
  cost: 0,
  mintedAmount: 0,
  maxSupply: 99999,
  maxMintAmountPerTransaction : 10,
  paused: true,
  error: false,
  errorMsg: "",
  viewCost: "-",
  cost: 1000000000000000
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATA_REQUEST":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        mintedAmount: action.payload.mintedAmount,
        maxSupply: action.payload.maxSupply,
        paused: action.payload.paused,
        cost: action.payload.cost,
        viewCost: action.payload.viewCost,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_FAILED":
      return {
        ...initialState,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
